import { cn } from "@/modules/lib/utils"
import { shortenText } from "@/modules/utils/stringUtils"
import { BoxPlaceIcon } from "@images/svgIcons/boxIcon"
import { useBox } from "@modules/box/hooks/useBox"
import { word } from "@modules/core/utils/i18n"
import { ProfileAvatar } from "@modules/profile/common/components/profileAvatar"
import { Text } from "@/components/ui/baseUi/text"

type BoxInfoResumeHeaderProps = {
  boxId: string
} & React.ComponentProps<"div">

export const BoxInfoResumeHeader = ({ boxId, className, ...props }: BoxInfoResumeHeaderProps) => {
  const { result: box } = useBox(boxId)

  return (
    <div
      className={cn(
        "relative flex h-60 w-full justify-center overflow-hidden rounded-b-4xl bg-surface-foreground",
        className,
      )}
      {...props}
    >
      <div className="mx-2 flex w-5/10 flex-col items-center justify-center gap-1">
        <ProfileAvatar className="size-18" profile={{ avatar: box?.logo ?? null, username: box?.name ?? "" }} />

        <Text fontStyle="TL">{shortenText(box?.name ?? "", 60)}</Text>

        <div className="flex items-center gap-2">
          <BoxPlaceIcon color="currentColor" className="text-textDefault-heading" />

          <Text fontStyle="BM">{word("global.box.name")}</Text>

          <Text fontStyle="LL">·</Text>

          <div className="flex flex-row flex-wrap gap-x-2">
            <Text fontStyle="LL">{box?.address.city}</Text>
            <Text fontStyle="BM">{box?.address.postalCode}</Text>
          </div>
        </div>
      </div>

      {box?.cover ? (
        <div
          className="h-full w-5/10"
          style={{ borderBottomRightRadius: "1rem", clipPath: "polygon(32% 0%, 100% 0%, 100% 100%, 0% 100%)" }}
        >
          <img src={box.cover.url} alt="box cover" className="h-full w-full object-cover" />
        </div>
      ) : null}
    </div>
  )
}
